import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { scrollToSection } from "../../utils/scrollToSection.ts";
import type { SectionId } from "../../constants/sections.ts";

type RedirectToSectionProps = {
  sectionId: SectionId;
  legacyHash?: string;
};

export default function RedirectToSection({
  sectionId,
  legacyHash,
}: RedirectToSectionProps) {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/", { replace: true });

    const targetId = legacyHash?.replace("#", "") || sectionId;
    const timer = window.setTimeout(() => {
      scrollToSection(targetId);
    }, 150);

    return () => window.clearTimeout(timer);
  }, [navigate, sectionId, legacyHash]);

  return null;
}
